import { useNode } from '@craftjs/core';
import React, { useCallback } from 'react';
import { Code } from '@descope/page-editor-components';
import { EditorInputSettings } from './EditorCodeSettings';

type Props = React.ComponentProps<typeof Code>;

const EditorCode = (props: Props) => {
	const {
		connectors: { connect, drag }
	} = useNode();

	const refCb = useCallback(
		(ref: HTMLDivElement) => connect(drag(ref)),
		[connect, drag]
	);

	// we are setting the input to read only value so it won't pop validations error message when editing the page
	// on the generated page the input element will not be read only
	return <Code ref={refCb} {...props} readOnly />;
};

EditorCode.craft = {
	name: 'One Time Code',
	props: {
		name: 'code',
		type: 'tel',
		label: 'Code',
		'data-errormessage-pattern-mismatch': 'Must be a 6 digits number',
		size: 'md' as Props['size'],
		fullWidth: false,
		required: true,
		digits: 6
	},
	related: {
		settings: EditorInputSettings
	}
};

export { EditorCode };
